import React, { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import Grid from '@mui/material/Grid';
import {Select, FormControl, InputLabel} from '@mui/material';
import styles from './Styles.css'
// import { Button } from '@mui/material';

export const NewBroadcastMessage = ({apiConfig, open, onClose, onSubmit}) => {

    const [broadcastMessage, setBroadcastMessage] = useState({
        BroadcastMessage: "", BroadcastSpeed: "", CreatedBy: "system", UpdatedBy: "system"
    })

    const handleChange = (e) => {
        setBroadcastMessage({
          ...broadcastMessage,
          [e.target.name]: e.target.value
        });
      };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Broadcastmessage Data:', broadcastMessage);
        // You can handle form submission logic here
        apiConfig.createAIBroadcast(broadcastMessage).then((response)=>{
            onSubmit(response.RobotResponse);
        })
    };

  return(
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box component="form" sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '50%',
          height: '50%',
          bgcolor: 'background.paper',
          border: '2px solid',
          borderColor: 'divider',
          borderRadius: 10,
          boxShadow: 24,
          p: 4,
          overflowY: "auto"
        }}
        onSubmit={handleSubmit}
        >
        <Grid container spacing={3} >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <p className={styles.font}>New Broadcast Message</p>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                    label="Broadcast Message"
                    variant="outlined"
                    name="BroadcastMessage"
                    style={{width: "100%"}}
                    value={broadcastMessage.BroadcastMessage}
                    onChange={handleChange}
                    required
                />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <FormControl variant="outlined" style={{width: "100%"}} required>
                    <InputLabel>BroadcastSpeed</InputLabel>
                    <Select
                    label="Broadcast Speed"
                    name="BroadcastSpeed"
                    value={broadcastMessage.BroadcastSpeed}
                    onChange={handleChange}
                    >
                    <MenuItem value="default">default</MenuItem>
                    <MenuItem value="x-slow">x-slow</MenuItem>
                    <MenuItem value="slow">slow</MenuItem>
                    <MenuItem value="medium">medium</MenuItem>
                    <MenuItem value="fast">fast</MenuItem>
                    <MenuItem value="x-fast">x-fast</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Button type="submit" variant="contained" color="primary">
                    Submit
                </Button>
            </Grid>
        </Grid>
      </Box>
    </Modal>
  )
}